import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Parallel } from "appworks/utils/contracts/parallel";
import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import { AlertComponent } from "slotworks/components/alert/alert-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { ReelSpinner } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import { RecoverFreespinsModeState } from "slotworks/state-machine/standard/states/recover-freespins-mode-state";

// TODO: why is there RecoverFreespinsState and RecoverFreespinsModeState?
export class RecoverFreespinsState extends RecoverFreespinsModeState {

    public complete() {
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);

        ReelSpinner.disableMinSpinTime = true;

        new Parallel([
            () => this.jumpStartSpin(),
            () => Components.get(AlertComponent).recover("rec.fre")
        ]).then(() => {
            gameWrapper.balancesUpdate(
                gameState.getCurrentGame().realBalance,
                gameState.getCurrentGame().freeBalance
            );

            gameWrapper.balancesUpdate(
                gameState.getCurrentGame().realBalance,
                gameState.getCurrentGame().freeBalance
            );
            super.complete();
        });
    }

    protected jumpStartSpin() {
        return Components.get(AbstractMatrixComponent).startTransition(true);
    }
}
